import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-page" }
const _hoisted_2 = { class: "plan-section" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "plan-steps" }
const _hoisted_5 = { class: "step" }
const _hoisted_6 = { class: "step-content" }
const _hoisted_7 = { class: "step-actions" }
const _hoisted_8 = { class: "step" }
const _hoisted_9 = { class: "step-content" }
const _hoisted_10 = { class: "step-actions" }
const _hoisted_11 = { class: "ongoing-section" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { class: "initiatives-grid" }
const _hoisted_14 = { class: "initiative-card" }
const _hoisted_15 = { class: "initiative-card" }
const _hoisted_16 = { class: "cta-section" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = { class: "cta-buttons" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ThePlanView',
  setup(__props) {

// No special logic needed for this static page

return (_ctx: any,_cache: any) => {
  const _component_givebutter_widget = _resolveComponent("givebutter-widget")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[30] || (_cache[30] = _createStaticVNode("<section class=\"hero\" data-v-f1f90f16><div class=\"container\" data-v-f1f90f16><h1 data-v-f1f90f16>The Plan</h1><p class=\"subtitle\" data-v-f1f90f16>A 5 step plan to solve a county-wide problem</p></div></section><section class=\"story-section\" data-v-f1f90f16><div class=\"container\" data-v-f1f90f16><div class=\"story-content\" data-v-f1f90f16><h2 data-v-f1f90f16>How it started</h2><p data-v-f1f90f16> When I first started this project, it was because I had a few old laptops not being used and asked a teacher if any of their students needed them. They told me of the 75 students graduating up to middle school, around <strong data-v-f1f90f16>50-60% would probably not have access to a computer at home</strong>. </p><p data-v-f1f90f16> So I set a personal goal to get 50 laptops by May of 2026 for these students before they started middle school. The plan was to just ask coworkers, friends, and family to get donations of old laptops. I thought I could help this class, but that the larger problem at the county level was out of my hands. </p></div></div></section><section class=\"discovery-section\" data-v-f1f90f16><div class=\"container\" data-v-f1f90f16><div class=\"discovery-content\" data-v-f1f90f16><h2 data-v-f1f90f16>Finding the source</h2><p data-v-f1f90f16> I received a handful of laptops, and a small amount of money to source used laptops on eBay. I noticed that a lot of Chromebooks from other school districts were being sold off in lots of 5-10 for $20-30 each. I bought a few of these lots, and refurbished them to be given to students at the school. But I knew that sellers on eBay do not work for free, and if they are selling these laptops for $20, there is a large supply of very cheap affordable laptops out there. </p><p data-v-f1f90f16> I started asking around and talking to people about where our school classroom laptops end up after they were decommissioned, and I learned about <strong data-v-f1f90f16>GovDeals.com</strong> which is a government surplus auction site. I found that school districts all over the country were selling off their used classroom laptops by the pallet. </p></div></div></section><section class=\"images-section\" data-v-f1f90f16><div class=\"container\" data-v-f1f90f16><div class=\"image-showcase\" data-v-f1f90f16><div class=\"image-card\" data-v-f1f90f16><img src=\"/assets/img/govdeals/556_chromebooks.webp\" alt=\"566 Chromebooks from Georgia School District\" data-v-f1f90f16></div><div class=\"image-card\" data-v-f1f90f16><img src=\"/assets/img/govdeals/556_chromebooks2.webp\" alt=\"Close-up of surplus Chromebooks\" data-v-f1f90f16></div><div class=\"image-card\" data-v-f1f90f16><img src=\"/assets/img/govdeals/pallets.webp\" alt=\"Pallets of surplus laptops\" data-v-f1f90f16></div></div><div class=\"breakthrough\" data-v-f1f90f16><h3 data-v-f1f90f16>The Solution</h3><p class=\"highlight-text\" data-v-f1f90f16> The going rate for these lots is around $5 per laptop when bought in bulk (500+). At this pricepoint the goal of ensuring every student in the county has access to technology at home starts to feel achievable. </p></div></div></section>", 4)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("h2", null, "So This is the Plan", -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"step completed\" data-v-f1f90f16><div class=\"step-icon\" data-v-f1f90f16><i class=\"icon\" data-v-f1f90f16>✓</i></div><div class=\"step-content\" data-v-f1f90f16><h3 data-v-f1f90f16>Build a Platform</h3><p data-v-f1f90f16>Created a public website and teacher portal to manage inventory and empower teachers to coordinate the needs of their students</p><span class=\"status-badge completed\" data-v-f1f90f16>Completed</span></div></div>", 1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "step-icon" }, [
              _createElementVNode("i", { class: "icon" }, "2")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Raise Funds", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("p", null, "Secure funding to purchase a wholesale lot of decommissioned laptops (Including power supplies and shipping costs)", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "status-badge" }, "In Progress", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_givebutter_widget, { id: "pXylnj" }),
                _createVNode(_component_router_link, {
                  to: "/donate?section=money",
                  class: "step-button donate-button"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("Donate", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"step\" data-v-f1f90f16><div class=\"step-icon\" data-v-f1f90f16><i class=\"icon\" data-v-f1f90f16>3</i></div><div class=\"step-content\" data-v-f1f90f16><h3 data-v-f1f90f16>Purchase Wholesale Lot</h3><p data-v-f1f90f16>Buy decommissioned laptops from school districts at wholesale prices</p><span class=\"status-badge\" data-v-f1f90f16>Upcoming</span></div></div>", 1)),
          _createElementVNode("div", _hoisted_8, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "step-icon" }, [
              _createElementVNode("i", { class: "icon" }, "4")
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Host Refurbishment Event", -1)),
              _cache[7] || (_cache[7] = _createElementVNode("p", null, "Weekend-long laptop refurbishment event with volunteers to prepare devices for students", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("span", { class: "status-badge" }, "Upcoming", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: "/volunteer",
                  class: "step-button volunteer-button"
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("Volunteer", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]),
          _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"step\" data-v-f1f90f16><div class=\"step-icon\" data-v-f1f90f16><i class=\"icon\" data-v-f1f90f16>5</i></div><div class=\"step-content\" data-v-f1f90f16><h3 data-v-f1f90f16>Distribute to Students</h3><p data-v-f1f90f16>Get laptops into the hands of students in need through their schools</p><span class=\"status-badge\" data-v-f1f90f16>Upcoming</span></div></div>", 1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[23] || (_cache[23] = _createElementVNode("h2", null, "What We'll Continue Doing", -1)),
        _cache[24] || (_cache[24] = _createElementVNode("p", { class: "section-intro" }, "While we work toward our 5-step plan, we're not stopping our current efforts to help students.", -1)),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "initiative-icon" }, "💻", -1)),
            _cache[16] || (_cache[16] = _createElementVNode("h3", null, "Accepting Donated Laptops", -1)),
            _cache[17] || (_cache[17] = _createElementVNode("p", null, "We continue to accept and refurbish donated laptops from individuals and businesses. Every laptop donated is one more student with access to technology.", -1)),
            _createVNode(_component_router_link, {
              to: "/donate?section=equipment",
              class: "initiative-link"
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("Learn More →", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "initiative-icon" }, "🏫", -1)),
            _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Working with Teachers", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("p", null, "We partner with teachers throughout Brevard County to identify students in need and ensure laptops get into the right hands through trusted school channels.", -1)),
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "initiative-link"
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("Get Involved →", -1)
              ]))]),
              _: 1
            })
          ]),
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "initiative-card" }, [
            _createElementVNode("div", { class: "initiative-icon" }, "🤝"),
            _createElementVNode("h3", null, "Engaging Officials"),
            _createElementVNode("p", null, "We'll be working with county and state officials to create a direct pipeline for decommissioned school laptops, cutting out the middleman and getting devices to students who need them.")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _cache[28] || (_cache[28] = _createElementVNode("h2", null, "Join Us in Making This Happen", -1)),
        _cache[29] || (_cache[29] = _createElementVNode("p", null, "Whether you can donate, volunteer, or spread the word—every bit helps us reach more students.", -1)),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: "/donate",
            class: "btn btn-primary"
          }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode("Support Our Mission", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/volunteer",
            class: "btn btn-secondary"
          }, {
            default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
              _createTextVNode("Volunteer", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "btn btn-outline"
          }, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
              _createTextVNode("Get in Touch", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})